module.exports = __webpack_public_path__ + "img/poster-banner.4207bbcd.jpg";